module.exports = __webpack_public_path__ + "static/media/bag.783bca67.svg";